export class TypeBo {
  constructor(public readonly id: number, public readonly code: string) {}
}
